/* unplugin-vue-components disabled */import { render } from "./normal.vue?vue&type=template&id=12e92556&scoped=true"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"

import "./normal.vue?vue&type=style&index=0&id=12e92556&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e92556"]])

export default __exports__